import React, { Component } from 'react';


import styles from  './styles.js';
import udsyn from  './assets/udsyn.jpg';
import budskab from  './assets/budskab.jpg';
import kunsten from  './assets/kunsten.jpg';
import indsigt from  './assets/indsigt.jpg';



class Gallery extends Component {

	render() {


		let imageStyle = {
			width: '100%',
			// display: 'block',
			// width: 'auto'
		}
		let imageContainer = {
			overflow: 'hidden',
			height: '25%',
			// width: '100%',
			// flexDirection: 'column',
			// flex: 1
			
		}

		let elmStyl = Object.assign({}, styles.container, {
			backgroundColor:'#000000',
		});
		let elmInnerStyl = Object.assign({}, styles.flex, {
			flexDirection: 'column',
			flex: 1,
			overflow: 'hidden',
		});

		return (
			<div style={elmStyl}>
				<div style={elmInnerStyl}>
					<div style={imageContainer}>
					<div
						data--100-start="margin-left: 200px"
						data-end="margin-left: 0px"
						>
						<img src={udsyn} style={imageStyle} alt='budskab'  />
					</div>
					</div>
					<div style={imageContainer}>
					<div
						data-0-start="margin-left: -200px"
						data-end="margin-left: 200px"
						>
						<img src={budskab} style={imageStyle} alt='budskab' />
					</div>
					</div>
					<div style={imageContainer}>
					<div
						data--100-start="margin-left: 200px"
						data-end="margin-left: -200px"
						>
						<img src={kunsten} style={imageStyle} alt='kunsten' />
					</div>
					</div>
					<div style={imageContainer}>
					<div
						data-0-start="margin-left: -200px"
						data-end="margin-left: 200px"
						>
						
						<img src={indsigt} style={imageStyle} alt='indsigt' />
						
					</div>
					</div>
				</div>
			</div>

		)
	}
}




export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.js